import React from 'react';

import CardHeader from '../../containers/CardHeader'

import { Card } from 'react-bootstrap';
import CPCDashboardTable from './CPCDashboardTable';

const CPCDashboard = () => {
    const title = "CPC Dashboard";
    const subtitle = "Listing of active CPC offers"

    return (
        <Card>
            <CardHeader title={title} description={subtitle} />
            <CPCDashboardTable />
        </Card>
    )
}

export default CPCDashboard;
